<template>
  <!-- Start Service Area  -->
  <v-row class="service-one-wrapper">
    <!-- Start Single Service  -->
    <v-col
      lg="6"
      md="6"
      sm="6"
      cols="12"
      v-for="(service, i) in serviceContent"
      :key="i"
    >
      <div class="single-service service__style--4">
        <router-link to="/services">
          <div class="service">
            <div class="icon" v-html="iconSvg(service.icon)"></div>
            <div class="content">
              <h3 class="heading-title">{{ service.title }}</h3>
              <p>
                {{ service.desc }}
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </v-col>
    <!-- End Single Service  -->
  </v-row>
  <!-- Start Service Area  -->
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        serviceContent: [
          {
            icon: "layers",
            title: "Web Development",
            desc: `From a simple website to a web application, we got you covered.`,
          },
          {
            icon: "pen-tool",
            title: "Graphic Design",
            desc: `Not sure how to represent your brand? Let us help.`,
          },
          {
            icon: "users",
            title: "Branding + Marketing",
            desc: `Let us handle your brand and watch your business grow.`,
          },
          {
            icon: "aperture",
            title: "Photo + Video",
            desc: `Want to show off your business on camera? Let us do that for you.`,
          },
        ],
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>
